import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { ExitComponent } from './exit/exit.component';
import { ResearcherTaskCommentComponent } from './researcherTaskComment/researcherTaskComment.component';
import { ResearcherTaskListComponent } from './researcherTaskList/researcherTaskList.component';
import { ResearcherTaskListHelpComponent } from './researcherTaskListHelp/researcherTaskListHelp.component';
import { SpecialInstructionComponent } from './specialInstruction/specialInstruction.component';
import { SortTaskListComponent } from './sortTaskList/sortTaskList.component';
import { SortTaskListHelpComponent } from './sortTaskListHelp/sortTaskListHelp.component';
import { WorkOrderReportComponent } from './workOrderReport/workOrderReport.component';
import OffenseComponent from './offense/offense.component';
import OffenseHelpComponent from './offenseHelp/offenseHelp.component';
import HelloWorldComponent from './helloWorld/helloWorld.component';
import NavigationComponent from './navigation/navigation.component';
import RegistrationComponent from './registration/registration.component';
import AuthenticationGuard from '../guards/authenticationGuard';
import ConfirmationComponent from './confirmation/confirmation.component';
import ReportsComponent from './reports/reports.component';
import InvoiceReportComponent from './invoiceReport/invoiceReport.component';

const appRoutes: Routes = [
  { path: '', component: LoginComponent },
  { path: 'login', component: LoginComponent },
  { path: 'comment', component: ResearcherTaskCommentComponent, canActivate: [AuthenticationGuard] },
  { path: 'specialInstruction', component: SpecialInstructionComponent, canActivate: [AuthenticationGuard] },
  { path: 'sortTaskList/:status', component: SortTaskListComponent, canActivate: [AuthenticationGuard] },
  { path: 'sortTaskListHelp', component: SortTaskListHelpComponent, canActivate: [AuthenticationGuard] },
  { path: 'workOrderReport', component: WorkOrderReportComponent, canActivate: [AuthenticationGuard] },
  { path: 'exit', component: ExitComponent},
  { path: 'registration', component: RegistrationComponent },
  { path: 'confirmation', component: ConfirmationComponent },
  { path: 'researcherHelp', component: ResearcherTaskListHelpComponent },
  { path: 'researcherTaskList/:status', component: ResearcherTaskListComponent, canActivate: [AuthenticationGuard] },
  { path: 'researcherTaskList/:status/:jurisdictionId', component: ResearcherTaskListComponent, canActivate: [AuthenticationGuard] },
  { path: 'offense/:requestNumber', component: OffenseComponent, canActivate: [AuthenticationGuard] },
  { path: 'offenseHelp', component: OffenseHelpComponent, canActivate: [AuthenticationGuard] },
  { path: 'helloworld', component: HelloWorldComponent, canActivate: [AuthenticationGuard] },
  { path: 'navigation', component: NavigationComponent, canActivate: [AuthenticationGuard] },
  { path: 'reports', component: ReportsComponent, canActivate: [AuthenticationGuard] },
  { path: 'invoiceReport/:startDate/:endDate/:invoiceNumber', component: InvoiceReportComponent, canActivate: [AuthenticationGuard] },
  { path: 'invoiceReport/:startDate/:endDate', component: InvoiceReportComponent, canActivate: [AuthenticationGuard] },
];

export const routing = RouterModule.forRoot(appRoutes, { useHash: true });



// WEBPACK FOOTER //
// ./src/app/app.routing.ts